<template>
  <div>
    <v-card elevation="6">
      <div class="pa-3">
        <div class="grid_select">
          <div class="grid_header_sell">
            <div class="mx-auto">
              <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_member" :src="img_member"/>
            </div>
            <div class="pt-3 pl-2" style="font-size: 26px"><b>ยอดขายแต่ละสมาชิก</b></div>
          </div>
          <div class="ma-2">
            <v-select color="#86bc3a" @input="dump_data_select()" :items="year_arr" item-text="show_year" item-value="year_eng" v-model="selected_year_member" prepend-inner-icon="mdi-calendar-month-outline" label="ปี พ.ศ." hide-details="auto" outlined></v-select>
          </div>
        </div>
      </div>
      <div class="pa-3" >
        <v-row>
            <v-col cols="6" md="3" lg="3">
              <v-card elevation="3">
                  <div class="pa-3">
                      <div class="grid_count mt-2">
                        <div class="mx-auto">
                            <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_money_bag_report" :src="img_money_bag_report"/>
                        </div>
                        <div class="ml-5 font_dairy"><b>ลูกค้าปลีก</b>
                          <div class="pt-0" style="font-size: 26px"><b>{{ format_number(total_order) }}</b></div>
                        </div>
                      </div>
                  </div>
              </v-card>
              <v-card elevation="3 mt-2">
                  <div class="pa-3">
                      <div class="grid_count mt-2">
                        <div class="mx-auto">
                            <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_money_bag_report" :src="img_money_bag_report"/>
                        </div>
                        <div class="ml-5 font_dairy"><b>ลูกค้าขายส่ง</b>
                            <div class=" pl-0" style="font-size: 26px"><b>{{ format_number(total_wholesale) }}</b></div>
                        </div>
                      </div>
                  </div>
              </v-card>
              <v-card elevation="3 mt-2">
                  <div class="pa-3">
                      <div class="grid_count mt-2">
                        <div class="mx-auto">
                            <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_money_bag_report" :src="img_money_bag_report"/>
                        </div>
                        <div class="ml-5 font_dairy"><b>ลูกค้าพาร์เนอร์</b>
                            <div class=" pl-0" style="font-size: 26px"><b>{{ format_number_total(total_partner) }}</b></div>
                        </div>
                      </div>
                  </div>
              </v-card>
              <v-card elevation="3 mt-2">
                  <div class="pa-3">
                      <div class="grid_count mt-2">
                        <div class="mx-auto">
                            <v-img class="mx-auto" height="64" width="64" max-width="64" :lazy-src="img_money_bag_report" :src="img_money_bag_report"/>
                        </div>
                        <div class="ml-5 font_dairy"><b>ลูกค้าอื่นๆ</b>
                            <div class=" pl-0" style="font-size: 26px"><b>{{ format_number(total_admin) }}</b></div>
                        </div>
                      </div>
                  </div>
              </v-card>
            </v-col>
            <v-col cols="6" md="9" lg="9" style="height: 50vh !important">
              <canvas id="myChartMember"></canvas>
            </v-col>
        </v-row>
        <!-- <div class="grid_member">
          <div class="mr-sm-5 pr-sm-5 mr-lg-5 pr-lg-5 mr-xl-5 pr-xl-5 border_right">
            <div class="ma-3">
              <v-btn style="width: 100%;" @click="total_sell_member(1)" class="pa-6 ma-2 grad-bg-outlined" :class="{'grad-bg-active': this.btn_active === 1}">ลูกค้าส่ง</v-btn>
            </div>
            <div class="ma-3">
              <v-btn style="width: 100%;" @click="total_sell_member(0)" class="pa-6 ma-2 grad-bg-outlined" :class="{'grad-bg-active': this.btn_active === 0}">ลูกค้าปลีก</v-btn>
            </div>
            <div class="ma-3">
              <v-btn style="width: 100%;" @click="total_sell_member(3)" class="pa-6 ma-2 grad-bg-outlined" :class="{'grad-bg-active': this.btn_active === 3}">พาร์ทเนอร์</v-btn>
            </div>
            <div class="ma-3">
              <v-btn style="width: 100%;" @click="total_sell_member(2)" class="pa-6 ma-2 grad-bg-outlined" :class="{'grad-bg-active': this.btn_active === 2}">อื่น ๆ</v-btn>
            </div>
          </div>
          <div v-if="loading_chart === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
              <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div v-else style="height: 40vh !important">
          </div>
        </div> -->
      </div>
    </v-card>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import {formatNumber} from "@/js/handler";
import img_member from "@/assets/pay_refund.png";
import img_money_bag_report from "@/assets/money-bag-report.png";
import {HTTP} from "@/axios";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Total_sell_member",
  data() {
    return {
      loading_chart: false,
      img_member: img_member,
      img_money_bag_report:img_money_bag_report,
      selected_year_member: null,
      year_arr: [],
      graph_list: [],
      graph_list_order_other: [],
      graph_list_order_partner: [],
      graph_list_order_wholesale: [],
      total_wholesale: 0,
      total_partner: 0,
      total_order: 0,
      total_admin: 0,
      btn_active: 1,
      myChartMember: null,
      year: [
        {id: 1, name: 'ปี 2565'},
        {id: 2, name: 'ปี 2564'},
        {id: 3, name: 'ปี 2563'},
        {id: 4, name: 'ปี 2562'},
        {id: 5, name: 'ปี 2561'},
      ],
    }
  },
  methods: {
    format_number_total(num) {
      return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    format_number: function (value) {
        return formatNumber(value)
    },
    async year_function() {
      this.year_arr = []
      let arr_year = [0, 1, 2]
      let count_year = new Date()
      let full_year = count_year.getFullYear()
      for (let i = 0; i < arr_year.length; i++) {
        let count_th = ((full_year + 543) - i);
        let count_eng = ((full_year) - i);
        this.year_arr.push({
          id: i,
          year_th: count_th,
          year_eng: count_eng,
          show_year: 'ปี ' + count_th,
        })
      }
      this.selected_year_member = this.year_arr[0].year_eng
      await this.dump_data_select()
    },
    async dump_data_select() {
      this.graph_list = []                  //ขายปลีก
      this.graph_list_order_other = []      //อื่นๆ
      this.graph_list_order_partner = []    //พาร์เนอร์
      this.graph_list_order_wholesale = []  //ขายส่ง
      await HTTP.post('/dashboards/salespermember', {
        year: this.selected_year_member,
        customer_type: this.btn_active,
      }).then((res) => {
        if (res.data.success === true) {
          this.total_wholesale  = res.data.total_wholesale  //ขายส่ง
          this.total_partner    = res.data.total_partner    //พาร์เนอร์
          this.total_order      = res.data.total_order      //ขายปลีก
          this.total_admin      = res.data.total_admin      //อื่นๆ
          res.data.object.forEach((data) => {
            this.graph_list.push(parseFloat(data.order))
            this.graph_list_order_other.push(parseFloat(data.order_other))
            this.graph_list_order_partner.push(parseFloat(data.order_partner))
            this.graph_list_order_wholesale.push(parseFloat(data.order_wholesale))
          })
          if (this.myChartMember !== null) {
            this.myChartMember.destroy()
          }
          this.chart_member()
        }
      })
    },
    chart_member() {
      let data = {
        labels: this.$store.state.monthThai,
        datasets: [
          {
            label: 'ลูกค้าปลีก',
            data: this.graph_list,
            borderColor: '#8CC63E',
            backgroundColor: '#8CC63E',
            fill: false
          },
          {
            label: 'ลูกค้าส่ง',
            data: this.graph_list_order_wholesale,
            borderColor: '#2b81d6',
            backgroundColor: '#2b81d6',
            fill: false
          },
          
          {
            label: 'พาร์ทเนอร์',
            data: this.graph_list_order_partner,
            borderColor: '#ac6100',
            backgroundColor: '#ac6100',
            fill: false
          },
          {
            label: 'อืนๆ',
            data: this.graph_list_order_other,
            borderColor: '#838383',
            backgroundColor: '#838383',
            fill: false
          },
        ]
      }
      let config = {
        type: 'bar',
        data: data,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: {
                stacked: true
            },
            y: {
                stacked: true
            }
          }
        }
      }
      const ctx = document.getElementById('myChartMember').getContext('2d');
      this.myChartMember = new Chart(ctx, config)
    },
    total_sell_member(type) {
      this.btn_active = type
      this.dump_data_select()
    },
  },
  mounted() {
    this.year_function()
  }
}
</script>

<style scoped>
.grid_select {
  display: grid;
  grid-template-columns: 80% 20%;
}
.grid_header_sell {
  display: grid;
  grid-template-columns: 10% 90%;
}
.grid_member {
  display: grid;
  grid-template-columns: 20% 80%;
}
.grid_count {
  display: grid;
  grid-template-columns: 20% 80%;
}
.border_right {
  border-right: #9b9b9b solid 2px
}
@media only screen and (max-width: 1180px) {
  .grid_select {
    display: grid;
    grid-template-columns: 70% 30%;
  }
  .grid_header_sell {
    display: grid;
    grid-template-columns: 22% 78%;
  }
  .grid_member {
    display: grid;
    grid-template-columns: 25% 75%;
  }
}
@media only screen and (max-width: 500px) {
  .grid_select {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_header_sell {
    display: grid;
    grid-template-columns: 25% 75%;
  }
  .grid_member {
    display: grid;
    grid-template-columns: 100%;
  }
  .border_right {
    border-right: none;
    margin-left: -15px !important;
  }
}
</style>
